//
// toggle the header of the address page based on the chosen path
//

var toggleAddressHeader = (function () {
    'use strict';

    // Variables
    const businessAddressInformation = "YOUR BUSINESS ADDRESS INFORMATION";
    const consumerAddressInformation = "YOUR ADDRESS INFORMATION";
    const businessAccounts = "YOUR BUSINESS ACCOUNTS";
    const consumerAccounts = "YOUR ACCOUNTS";
    const businessReasonsForSeeking = "REASON(S) FOR SEEKING FINANCIAL ASSISTANCE FOR YOUR BUSINESS";
    const consumerReasonsForSeeking = "REASON(S) FOR SEEKING FINANCIAL ASSISTANCE";

    const businessAnalyticsPageName = "your-business-address-information";
    const consumerAnalyticsPageName = "your-address-information";
    const reasonsBusinessAnalyticsPageName = "reasons-for-seeking-financial-assistance-for-your-business";
    const reasonsConsumerAnalyticsPageName = "reasons-for-seeking-financial-assistance";
    const accountsBusinessAnalyticsPageName = "your-business-accounts";
    const accountsConsumerAnalyticsPageName = "your-accounts";



    var pathInputsSelector = "[name^='path_']";
    var separator = "div[data-sf-role='separator']";

    // Methods
    function getCurrentPath() {

        var pathInputs = $(`${pathInputsSelector}:checked`);
        var yesCount = 0;

        for (var pathInput of pathInputs.toArray()) {
            if ($(pathInput).val() == "Yes") {
                yesCount++;
            }
        }

        return yesCount == 3 ? "Business" : "Consumer";
    }


    function changeHeaders(element, sectionHeader, analyticsPageName) {
        $(element).parents(separator).find('span[analytics-role="name"]').attr("analytics-data", analyticsPageName).text(sectionHeader);
    }

    $(document).ready(function () {
        var $pathInput = $("input[name='path']");

        $('[data-sf-btn-role="next"]').click(function () {
            var value = getCurrentPath(),
                headerSeparator = $(separator).eq(3),
                header = headerSeparator.find('span[analytics-role="name"]');

            if (value === "Consumer") {
                header.text(consumerAddressInformation);
                $(header).attr("analytics-data", consumerAnalyticsPageName);
                changeHeaders('[data-sf-role-field-name="main_reason_for_financial_assistane"]', consumerReasonsForSeeking, reasonsConsumerAnalyticsPageName);
                changeHeaders('[data-sf-role-field-name="accounts"]', consumerAccounts, accountsConsumerAnalyticsPageName);

            } else {
                header.text(businessAddressInformation);
                $(header).attr("analytics-data", businessAnalyticsPageName);
                changeHeaders('[data-sf-role-field-name="main_reason_for_financial_assistane"]', businessReasonsForSeeking, reasonsBusinessAnalyticsPageName);
                changeHeaders('[data-sf-role-field-name="accounts"]', businessAccounts, accountsBusinessAnalyticsPageName);
            }

        });


    });
})();